module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/perforation1.467fc5de.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/perforation1.png
// module id = 302
// module chunks = 0